import * as React from 'react';



export default class selectArrow extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <g id="Reservation-of-rights-CC-Add-Feature" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="02.-CC-Grouping-" transform="translate(-1012.000000, -471.000000)" fill="#727272">
            <g id="Group" transform="translate(1012.000000, 467.000000)">
                <g id="Icons-/-16-x-16-/-Light-/-Arrow" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) ">
                    <g id="Group-53" transform="translate(4.000000, 0.000000)">
                        <g id="Rectangle-2">
                            <polygon id="Rectangle" transform="translate(4.531434, 4.382134) rotate(-46.000000) translate(-4.531434, -4.382134) " points="3.9248127 -1.05860114 4.9248127 -1.05860114 5.13805563 9.82286983 4.18464005 9.65259009"></polygon>
                        </g>
                        <polygon id="Rectangle" transform="translate(4.670950, 11.377111) rotate(-135.000000) translate(-4.670950, -11.377111) " points="4.19233874 5.80855916 5.19233874 5.80855916 5.19179026 12.0238053 5.19136156 16.8818094 4.1495616 16.9456622"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </g>
      </svg>
    )
  }
}
